import { overlay } from "overlay-kit";
import QuickStartCloseDialog from "../dialog/quick-start-close-dialog";
import QuickStartDialog from "../dialog/quick-start-dialog";
import { Button } from "../ui/button";
import CloseIcon from "../ui/icons/CloseIcon";
import { Text } from "../ui/text";
import useQuickStartStore from "@/stores/quick-start";
import { useLocation } from "react-router-dom";

const QuickStartButton = () => {
  const { isVisible } = useQuickStartStore();

  const { pathname } = useLocation();

  const handleQuickStart = () => {
    overlay.open(({ isOpen, close }) => (
      <QuickStartDialog isOpen={isOpen} onClose={() => close()} />
    ));
  };

  const handleCloseQuickStart = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    overlay.open(({ isOpen, close }) => (
      <QuickStartCloseDialog isOpen={isOpen} onClose={() => close()} />
    ));
  };

  if (!isVisible || pathname.includes("ai-agent")) return null;

  return (
    <Button
      onClick={handleQuickStart}
      className={`fixed ${
        pathname.includes("searched") ? "right-[90px]" : "right-[10px]"
      } bottom-5 flex items-center gap-[24px] py-[10px] rounded-[8px] `}
    >
      <Text variant={"title-lg"} className="text-white">
        Quick start
      </Text>
      <div onClick={handleCloseQuickStart}>
        <CloseIcon color="#fff" />
      </div>
    </Button>
  );
};

export default QuickStartButton;
